export default __webpack_public_path__ + "static/media/Background_00086.cc171ddb.png";